import React from 'react';

import PlaceholderTab from '../../shared/PlaceholderTab';

import { DEAL_OPTION_FIELDS } from './fields';

export default function DealOptionsTab() {
  return <PlaceholderTab configuredFieldCount={DEAL_OPTION_FIELDS.length} title="Deal Options" />;
}
